module.exports = __webpack_public_path__ + "img/vknows_small.1a0b7aae.png";